import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Producto } from '../../../_models/producto';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { ListaItem } from '../../../_models/lista-item';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavService } from '../../../_services/_nav.service';
import { Location } from '@angular/common';
import { ListaService } from '../../../_services/lista.service';
import {forkJoin, Observable} from 'rxjs';
import { ProductoReferencia } from '../../../_models/producto-referencia';
import { ProductoReferenciaService } from '../../../_services/producto-referencia.service';
import { Cuestionario } from '../../../_models/cuestionario';
import { CuestionarioService } from '../../../_services/cuestionario.service';
import { Table } from 'primeng/table';
import { Funcionalidad } from '../../../_models/funcionalidad';
import { AutenticacionService } from '../../../_services/autenticacion.service';
import { ProductoVinculacionMinimoService } from '../../../_services/producto-vinculacion-minimo.service';
import { ProductoVinculacionMinimo } from '../../../_models/producto-vinculacion-minimo';
import {ProductoReferenciasParentescos} from "../../../_models/producto-referencias-parentescos";
import {ProductoReferenciasParentescosService} from "../../../_services/producto-referencias-parentescos.service";
import {FlujoProcesoService} from '../../../_services/flujo-proceso.service';
import {ProductosReferenciasTiposPersonas} from '../../../_models/productosreferenciastipospersonas';
import {ProductosreferenciastipospersonasService} from '../../../_services/productosreferenciastipospersonas.service';

@Component( {
  selector: 'app-producto-referencia',
  templateUrl: 'producto-referencia.component.html'
} )

export class ProductoReferenciaComponent implements OnInit {

  @Input() producto: Producto;
  @Input() listaTiposPersonas: SelectItem[] = [];
  lisVinculacion: SelectItem[] = [];
  lisVinculacionTodos: ListaItem[] = [];
  lisReferencia: SelectItem[] = [];
  lisCalificacionesReferencias: SelectItem[] = [];
  lisCalificacionesReferenciasTodos: ListaItem[] = [];
  indObligatorio: boolean = false;
  lisReferenciaTodos: ListaItem[] = [];
  lisCuestionarios: SelectItem[] = [];
  lisCuestionariosTodos: Cuestionario[] = [];
  carInformacionInicial = true;
  lisProductosReferencias: ProductoReferencia[] = [];
  lisProductosReferenciasTodos: ProductoReferencia[] = [];
  formulario: FormGroup;
  submitted = false;
  guardando = true;
  columnas: any[];
  proReferenciaSeleccionada: ProductoReferencia;
  tab = 'L';
  tabSeleccionado = 'REFOBL';
  lisTipoUsoCelular: SelectItem[] = [];
  lisTipoUsoCelularTodos: ListaItem[] = [];

  listParentescoTodos: ListaItem[];
  listParentesco: SelectItem[];
  productoReferenciaParentesco: ProductoReferenciasParentescos[];
  listaProductosReferenciasTiposPersonas: ProductosReferenciasTiposPersonas[] = [];
  busqueda: string;
  @ViewChild('dt') tabla: Table;
  menu: Funcionalidad = new Funcionalidad();
  tipTelefonoPersonal: ListaItem;
  refrescar = {};

  constructor( private proReferenciasServicio: ProductoReferenciaService,
               private navServicio: NavService,
               private fb: FormBuilder,
               private location: Location,
               private conServicio: ConfirmationService,
               private lisServicio: ListaService,
               private cueServicio: CuestionarioService,
               private autServicio: AutenticacionService,
               private serProductoVincualcionMinimo: ProductoVinculacionMinimoService,
               private productoRefParenService: ProductoReferenciasParentescosService,
               private fluProcesoService: FlujoProcesoService,
               private productosreferenciastipospersonasServicio: ProductosreferenciastipospersonasService
               ) {
  }

  ngOnInit(): void {
    this.productoReferenciaParentesco = [];
    this.listaProductosReferenciasTiposPersonas = [];
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'ceu/insumo-pecuario' );
    if ( mn ) {
      this.menu = mn;
    }

    this.columnas = [
      { field: 'nombreTipoUsoCelular', header: this.navServicio.buscarMensaje( 'PRODUCTOREFERENCIA.LBL_TIPOUSOCELULAR' ), sort: false },
      { field: 'tipoReferencia', header: this.navServicio.buscarMensaje( 'PRODUCTOREFERENCIA.LBL_TIPOREFERENCIA' ), sort: false },
      { field: 'tipoVinculacion', header: this.navServicio.buscarMensaje( 'PRODUCTOREFERENCIA.LBL_TIPOVINCULACION' ), sort: false },
      { field: 'tipoPersona', header: this.navServicio.buscarMensaje( 'PRODUCTOREFERENCIA.LBL_NATURALEZA' ), sort: false },
      { field: 'numeroReferencias', header: this.navServicio.buscarMensaje( 'PRODUCTOREFERENCIA.LBL_NUMEROREFERENCIAS' ), sort: false },
      { field: 'indicadorCanalAnalizamos', header: this.navServicio.buscarMensaje( 'PRODUCTOREFERENCIA.LBL_CHECKANALIZAMOS' ), sort: false },
      { field: 'indicadorCanalDigital', header: this.navServicio.buscarMensaje('PRODUCTOREFERENCIA.LBL_CHECKDIGITAL'), sort: false},
      { field: 'cuestionario', header: this.navServicio.buscarMensaje( 'PRODUCTOREFERENCIA.LBL_CUESTIONARIO' ), sort: false },
      { field: 'indicadorCalificarReferencias', header: this.navServicio.buscarMensaje( 'PRODUCTOREFERENCIA.LBL_CHECKCALIFICARREFERENCIA' ), sort: false },
      { field: 'funcionaliad', header: this.navServicio.buscarMensaje( 'PRODUCTOREFERENCIA.LBL_FUNCIONALIDAD' ), sort: false },
      { field: 'obligatorio', header: this.navServicio.buscarMensaje( 'PRODUCTOREFERENCIA.LBL_OBLIGATORIO' ), sort: false },
      /*{ field: 'indicadorWeb', header: this.navServicio.buscarMensaje( 'PRODUCTOREFERENCIA.LBL_CHECKWEB' ), sort: false },
      { field: 'indicadorMovil', header: this.navServicio.buscarMensaje( 'PRODUCTOREFERENCIA.LBL_CHECKMOVIL' ), sort: false },*/
      {
        field: 'cuestionarioConfirmarReferencia',
        header: this.navServicio.buscarMensaje( 'PRODUCTOREFERENCIA.LBL_CUESTIONARIOSCALREF' ),
        sort: false
      },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    this.busqueda = this.navServicio.getSearch( 'producto-referencia.component' );
    forkJoin( this.proReferenciasServicio.listadoPorProductoTipoPersona( this.producto.idProducto ),
      this.lisServicio.getMasterDetails( ' ListasTiposReferencias' ),
      this.lisServicio.getMasterDetails( ' ListasTiposVinculaciones' ),
      this.lisServicio.getMasterDetails( ' ListasTiposUsosTelefonos' ),
      this.lisServicio.getMasterDetails( ' ListasFuncionalidadesCalificacionesReferencias' ),
      this.fluProcesoService.lisParentescoFiltrado( true ),
      this.cueServicio.listadoConRespuesta() ).subscribe( ( [ lisProductosReferencias, lisTiposReferencias, lisTiposVinculaciones, lisTipoUsoCelular, calificacionesReferencias, lisParentesco, lisCuestionarios ] ) => {
      this.lisVinculacionTodos = lisTiposVinculaciones;
      this.lisReferenciaTodos = lisTiposReferencias;
      this.listParentescoTodos = lisParentesco;
      this.lisProductosReferenciasTodos = lisProductosReferencias;
      this.cargarReferencias();
      this.lisCuestionariosTodos = lisCuestionarios;
      this.lisTipoUsoCelularTodos = lisTipoUsoCelular;
      this.cargarTipoCelular();
      this.cargarCombos();
      this.cargarFormulario();
      this.carInformacionInicial = false;
      this.guardando = false;
      //this.tabla.filterGlobal( this.busqueda, 'contains' );
      this.lisCalificacionesReferenciasTodos = calificacionesReferencias;
      calificacionesReferencias.forEach( y => this.lisCalificacionesReferencias.push({label: y.nombre, value: y.idLista}));
    } );
  }

  async cargarReferencias(lanzarServicio: boolean = false) {
    if (lanzarServicio) {
        this.lisProductosReferenciasTodos = await this.proReferenciasServicio.listadoPorProductoTipoPersona( this.producto.idProducto ).toPromise();
    }
    this.lisProductosReferencias = [ ...this.lisProductosReferenciasTodos.filter( x => x.indicadorHabilitado ) ];
    this.lisProductosReferencias.forEach(x => {
      if (Array.isArray(x.naturaleza) && x.naturaleza.length > 0) {
        const lista = x.naturaleza.filter(l =>l.indicadorHabilitado ).map(l => l.tipoPersona);
        x.tipoPersona = lista.join(',');

      }
    });
    this.refrescar = { estado: true };
  }

  cargarTipoCelular() {
    this.lisTipoUsoCelular = [];
    this.lisTipoUsoCelularTodos.map( ( s: ListaItem ) => {
      this.lisTipoUsoCelular.push( { label: s.nombre, value: s.idLista } );
      if ( s.codigo === 'NPER' ) {
        this.tipTelefonoPersonal = s;
      }
    } );
  }

  cargarCombos() {
    this.lisVinculacion = [];
    this.lisVinculacionTodos.map( ( s: ListaItem ) => {
      this.lisVinculacion.push( { label: s.nombre, value: s.idLista } );
    } );

    this.lisReferencia = [];
    this.lisReferenciaTodos.map( ( s: ListaItem ) => {
      if ( s.codigo !== 'REFUPA' ) {
        this.lisReferencia.push( { label: s.nombre, value: s.idLista } );
      }
    } );
    this.lisCuestionarios = [];
    this.lisCuestionarios.push( { label: this.navServicio.buscarMensaje( 'LBL_NOAPLICA' ), value: '000' } );
    this.lisCuestionariosTodos.map( ( s: Cuestionario ) => {
      if ( s.indicadorHabilitado ) {
        this.lisCuestionarios.push( { label: s.nombre, value: s.idCuestionario } );
      }
    } );
    this.listParentesco = [];
    this.listParentescoTodos.map( (s: ListaItem) => {
      this.listParentesco.push({label: s.nombre, value: s.idLista});
    });
  }


  cargarFormulario() {
    const ids = [];
    if(this.productoReferenciaParentesco.length >0){
      this.productoReferenciaParentesco.forEach(e => {
        if(e.indicadorHabilitado && this.listParentesco.find(p => p.value === e.idParentesco)){
          ids.push(e.idParentesco);
        }
      });
    }

    const naturaleza = [];
    if (this.proReferenciaSeleccionada && Array.isArray(this.proReferenciaSeleccionada.naturaleza) && this.proReferenciaSeleccionada.naturaleza.length > 0 ) {
      this.proReferenciaSeleccionada.naturaleza.forEach( e => {
        if ( e.indicadorHabilitado ) {
          naturaleza.push( e.idTipoPersona );
        }
      } );
    }

    this.formulario = this.fb.group( {
      idProductoReferencia: [ this.proReferenciaSeleccionada ? this.proReferenciaSeleccionada.idProductoReferencia : null ],
      idProducto: [ this.proReferenciaSeleccionada ? this.proReferenciaSeleccionada.idProducto : this.producto.idProducto, [ Validators.required ] ],
      idTipoReferencia: [ this.proReferenciaSeleccionada ? this.proReferenciaSeleccionada.idTipoReferencia : null, [ Validators.required ] ],
      idTipoVinculacion: [ this.proReferenciaSeleccionada ? this.proReferenciaSeleccionada.idTipoVinculacion : null, [ Validators.required ] ],
      idTipoUsoTelefono: [ this.proReferenciaSeleccionada ? this.proReferenciaSeleccionada.idTipoUsoTelefono : ( this.tipTelefonoPersonal ? this.tipTelefonoPersonal.idLista : null ), [ Validators.required ] ],
      numeroReferencias: [ this.proReferenciaSeleccionada ? this.proReferenciaSeleccionada.numeroReferencias : null, [ Validators.required, Validators.maxLength( 3 ) ] ],
      indicadorHabilitado: [ this.proReferenciaSeleccionada ? this.proReferenciaSeleccionada.indicadorHabilitado : true ],
      indicadorCalificarReferencias: [ this.proReferenciaSeleccionada ? this.proReferenciaSeleccionada.indicadorCalificarReferencias : false ],
      indicadorParentesco: [ this.proReferenciaSeleccionada ? this.proReferenciaSeleccionada.indicadorParentesco : false ],
      indicadorCanalAnalizamos: [ this.proReferenciaSeleccionada ? this.proReferenciaSeleccionada.indicadorCanalAnalizamos : false],
      indicadorCanalDigital: [this.proReferenciaSeleccionada ? this.proReferenciaSeleccionada.indicadorCanalDigital: false],
      auditoriaUsuario: [ this.proReferenciaSeleccionada ? this.proReferenciaSeleccionada.auditoriaUsuario : null ],
      auditoriaFecha: [ this.proReferenciaSeleccionada ? this.proReferenciaSeleccionada.auditoriaFecha : null ],
      tipoReferencia: [ this.proReferenciaSeleccionada ? this.proReferenciaSeleccionada.tipoReferencia : null ],
      tipoVinculacion: [ this.proReferenciaSeleccionada ? this.proReferenciaSeleccionada.tipoVinculacion : null ],
      nombreTipoUsoCelular: [ this.proReferenciaSeleccionada ? this.proReferenciaSeleccionada.nombreTipoUsoCelular : null ],
      producto: [ this.proReferenciaSeleccionada ? this.proReferenciaSeleccionada.producto : null ],
      idCuestionario: [ this.proReferenciaSeleccionada && this.proReferenciaSeleccionada.idCuestionario ? this.proReferenciaSeleccionada.idCuestionario : '000' ],
      idCuestionarioConfirmarReferencia: [ this.proReferenciaSeleccionada && this.proReferenciaSeleccionada.idCuestionarioConfirmarReferencia ? this.proReferenciaSeleccionada.idCuestionarioConfirmarReferencia : '000' ],
      idFuncionalidad: [ this.proReferenciaSeleccionada && this.proReferenciaSeleccionada.idFuncionalidad ? this.proReferenciaSeleccionada.idFuncionalidad : null ],
      idParentescos: [ ids ],
      idNaturaleza: [ naturaleza, [ Validators.required ] ],
      // Estos indicadores van a ser removidos en el futuro.
      // indicadorWeb: [ this.proReferenciaSeleccionada ? this.proReferenciaSeleccionada.indicadorWeb : false ],
      // indicadorMovil: [ this.proReferenciaSeleccionada ? this.proReferenciaSeleccionada.indicadorMovil : false ],
      indicadorWeb: [ true ],
      indicadorMovil: [ true ],
      indicadorObligatorio: [this.proReferenciaSeleccionada && this.proReferenciaSeleccionada.indicadorObligatorio ? this.proReferenciaSeleccionada.indicadorObligatorio : false ],
    } );
  }

  get f() {
    return this.formulario.controls;
  }

  noAplica( id ) {
    return id === '000' ? null : id;
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid && this.validarIndicadoresSistema() && this.validar()) {
      this.guardando = true;
      const formulario = this.formulario.value;
      if ( formulario.idProductoReferencia ) {
        this.serProductoVincualcionMinimo.listadoPorProducto( this.producto.idProducto ).subscribe( reg => {
          let numReferencia = 0;
          reg.map( ( s: ProductoVinculacionMinimo ) => {
            if ( s.idTipoVinculacion === formulario.idTipoVinculacion && s.idTipoUsoTelefono === formulario.idTipoUsoTelefono && !!s.referencias.find( y => y.indicadorHabilitado && y.idTipoReferencia === formulario.idTipoReferencia ) ) {
              numReferencia += s.nroReferencias;
            }
          } );

          if ( numReferencia <= formulario.numeroReferencias ) {
            formulario.idCuestionario = this.noAplica(formulario.idCuestionario);
            formulario.idCuestionarioConfirmarReferencia = this.noAplica(formulario.idCuestionarioConfirmarReferencia);
            this.proReferenciasServicio.actualizar( formulario ).subscribe( referencia => {
              if ( formulario.idCuestionario && formulario.idCuestionario !== '000' ) {
                const b = this.lisCuestionariosTodos.find( y => y.idCuestionario == formulario.idCuestionario );
                if ( b ) {
                  formulario.cuestionario = b.nombre;
                }
              }

              if ( formulario.idCuestionarioConfirmarReferencia && formulario.idCuestionarioConfirmarReferencia !== '000' ) {
                const b = this.lisCuestionariosTodos.find( y => y.idCuestionario == formulario.idCuestionarioConfirmarReferencia );
                if ( b ) {
                  formulario.cuestionarioConfirmarReferencia = b.nombre;
                }
              }
              const a = this.lisProductosReferenciasTodos.findIndex( x => x.idProductoReferencia === formulario.idProductoReferencia );
              if ( a >= 0 ) {
                this.lisProductosReferenciasTodos[ a ] = formulario;
              }

              this.subirProductoReferenciaParentesco(referencia.idProductoReferencia);
              this.referenciasTipoPersona(referencia.idProductoReferencia);
              this.cargarReferencias(true);
              this.reiniciarFormulario();
              this.tab = 'L';
              this.guardando = false;
              this.navServicio.setMesage( 1 );
            }, error => {
              this.guardando = false;
              this.navServicio.setMesage( 3 );
            } );
          } else {
            this.navServicio.setMesage( 0, {
              severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
              detail: this.navServicio.buscarMensaje( 'PRODUCTOREFERENCIA.MSG_ERRORNUMREF' )
            } );
            this.guardando = false;
          }
        } );
      } else {
        const validacion = this.lisProductosReferenciasTodos.find( x => x.idTipoReferencia == formulario.idTipoReferencia &&
          x.idTipoVinculacion == formulario.idTipoVinculacion &&
          x.idTipoUsoTelefono === formulario.idTipoUsoTelefono &&
          (x.indicadorCanalDigital == formulario.indicadorCanalDigital || x.indicadorCanalAnalizamos == formulario.indicadorCanalAnalizamos));
        if ( !validacion ) {
          formulario.idCuestionario = this.noAplica(formulario.idCuestionario);
          formulario.idCuestionarioConfirmarReferencia = this.noAplica(formulario.idCuestionarioConfirmarReferencia);
          this.proReferenciasServicio.crear( formulario ).subscribe( referencia => {
            this.referenciasTipoPersona(referencia.idProductoReferencia);
            this.subirProductoReferenciaParentesco(referencia.idProductoReferencia);
            this.actualizarDataTable();
            this.reiniciarFormulario();
            this.guardando = false;
            this.navServicio.setMesage( 1 );
            this.tab = 'L';
          }, error => {
            this.guardando = false;
            this.navServicio.setMesage( 3 );
          } );
        } else if ( validacion && !validacion.indicadorHabilitado ) {
          formulario.idProductoReferencia = validacion.idProductoReferencia;
          formulario.indicadorHabilitado = true;
          formulario.idCuestionario = this.noAplica(formulario.idCuestionario);
          formulario.idCuestionarioConfirmarReferencia = this.noAplica(formulario.idCuestionarioConfirmarReferencia);
          this.proReferenciasServicio.actualizar( formulario ).subscribe( referencia => {
            this.referenciasTipoPersona(referencia.idProductoReferencia);
            this.subirProductoReferenciaParentesco(referencia.idProductoReferencia);
            this.actualizarDataTable();
            this.reiniciarFormulario();
            this.guardando = false;
            this.navServicio.setMesage( 1 );
            this.tab = 'L';
          } );
        } else {
          this.navServicio.setMesage( 0, {
            severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.navServicio.buscarMensaje( 'PRODUCTOREFERENCIA.MSG_SONIGUALES' )
          } );
          this.guardando = false;
        }
      }
    }

  }


  subirProductoReferenciaParentesco(idProductoReferencia: string){

    const forData = this.formulario.value;
    const tempProductoReferenciaParentescos: ProductoReferenciasParentescos[] = [];
    if(forData.idParentescos.length>0){
      forData.idParentescos.forEach( idParentesco => {
        let temp = {} as ProductoReferenciasParentescos;
        temp.idProductoReferencia = idProductoReferencia;
        temp.idParentesco = idParentesco;
        temp.indicadorHabilitado = true;
        temp.auditoriaFecha = forData.auditoriaFecha;
        temp.auditoriaUsuario = forData.auditoriaUsuario;
        if(this.productoReferenciaParentesco.length>0){
          const a = this.productoReferenciaParentesco.find( sp => sp.idParentesco === temp.idParentesco );
          if ( a ) {
            temp.idProductoReferenciaParentesco = a.idProductoReferenciaParentesco;
          }
        }
        tempProductoReferenciaParentescos.push( temp );
      } );
    }
    this.productoReferenciaParentesco.forEach( e => {
      if ( e.indicadorHabilitado && !forData.idParentescos.find( y => y === e.idParentesco ) ) {
        e.indicadorHabilitado = false;
        tempProductoReferenciaParentescos.push( e );
      }
    } );

    if ( tempProductoReferenciaParentescos.length > 0 ) {
      this.productoRefParenService.bulk(tempProductoReferenciaParentescos).subscribe(s => {
        this.productoReferenciaParentesco = [];
        this.productoReferenciaParentesco = s;
        this.navServicio.setMesage( 1 );
      });
    }

  }

  async referenciasTipoPersona(idProductoReferencia: string) {
    const _data = this.formulario.value;
    const lista: ProductosReferenciasTiposPersonas[] = [];
    if(_data.idNaturaleza.length > 0) {
      _data.idNaturaleza.forEach(n => {
        let obj = {} as ProductosReferenciasTiposPersonas;
        obj.idProductoReferencia = idProductoReferencia;
        obj.idTipoPersona = n;
        obj.indicadorHabilitado = true;
        obj.auditoriaUsuario = _data.auditoriaUsuario;
        if (this.proReferenciaSeleccionada && Array.isArray(this.proReferenciaSeleccionada.naturaleza) && this.proReferenciaSeleccionada.naturaleza.length > 0) {
          const x = this.proReferenciaSeleccionada.naturaleza.find(l => l.idProductoReferencia === idProductoReferencia && l.idTipoPersona === n);
          if (x) {
            obj.idProductoReferenciaTipoPersona = x.idProductoReferenciaTipoPersona;
          }

        }
        lista.push(obj);
      });

      if (this.proReferenciaSeleccionada && Array.isArray(this.proReferenciaSeleccionada.naturaleza) && this.proReferenciaSeleccionada.naturaleza.length > 0) {
        this.proReferenciaSeleccionada.naturaleza.forEach( e => {
          if ( e.indicadorHabilitado && !_data.idNaturaleza.find( y => y === e.idTipoPersona ) ) {
            e.indicadorHabilitado = false;
            lista.push( e );
          }
        } );
      }

      if (lista.length > 0) {
        await this.productosreferenciastipospersonasServicio.bulk(lista).toPromise();
      }
    }
  }

  showMessage( titulo: string, mensaje: string, severity: string = 'info' ) {
    this.navServicio.setMesage( 0, {
      severity: severity, summary: this.navServicio.buscarMensaje( titulo ),
      detail: this.navServicio.buscarMensaje( mensaje ), key: 'form-paso-flujo'
    } );
  }


  reiniciarFormulario() {
    this.proReferenciaSeleccionada = null;
    this.cargarFormulario();
    this.formulario.markAsPristine();
    this.submitted = false;
  }

  editar( proReferencia: ProductoReferencia ) {
    this.proReferenciaSeleccionada = proReferencia;
    this.productoRefParenService.listadoPorIdProductoReferencia(this.proReferenciaSeleccionada.idProductoReferencia).subscribe(respuesta => {
      this.productoReferenciaParentesco = respuesta;
      this.validarFuncionalidadSeleccionada(this.proReferenciaSeleccionada?.idFuncionalidad ? this.proReferenciaSeleccionada?.idFuncionalidad : null)
      this.cargarFormulario();
    });
      this.submitted = false;
    this.cargarFormulario();
      this.tab = 'E';
  }

  inhabilitar( registro: ProductoReferencia ) {
    this.carInformacionInicial = true;
    this.serProductoVincualcionMinimo.listadoPorProducto( this.producto.idProducto ).subscribe(reg => {
      if ( reg.find( c => c.idTipoVinculacion === registro.idTipoVinculacion && c.idTipoUsoTelefono === registro.idTipoUsoTelefono && c.indicadorHabilitado && !!c.referencias.find( y => y.indicadorHabilitado && y.idTipoReferencia === registro.idTipoReferencia ) ) ) {
        this.navServicio.setMesage( 0, {
          severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
          detail: this.navServicio.buscarMensaje( 'PRODUCTOREFERENCIA.MSG_ERRORBORRAR' )
        } );
        this.carInformacionInicial = false;
      } else {
        registro.indicadorHabilitado = false;
        registro.idCuestionario = this.noAplica(registro.idCuestionario);
        registro.idCuestionarioConfirmarReferencia = this.noAplica(registro.idCuestionarioConfirmarReferencia);
        this.proReferenciasServicio.actualizar( registro ).subscribe( async regAct => {
          if (Array.isArray(registro.naturaleza) && registro.naturaleza.length > 0) {
            registro.naturaleza.forEach(l=> {
              l.indicadorHabilitado = false;
            });
            await this.productosreferenciastipospersonasServicio.bulk(registro.naturaleza).toPromise();
          }
          this.navServicio.setMesage( 2 );
          this.actualizarDataTable();
        } );
      }
    } );
  }

  actualizarDataTable() {
    this.lisProductosReferenciasTodos = [];
    this.guardando = true;
    this.proReferenciasServicio.listadoPorProductoTipoPersona( this.producto.idProducto ).subscribe( reg => {
      this.lisProductosReferenciasTodos = reg;
      this.cargarReferencias(true);
      this.guardando = false;
      this.carInformacionInicial = false;
    } );
  }

  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'referencias',
        accept: () => {
          this.reiniciarFormulario();
          this.tab = 'L';
        },
        reject: () => {
        }
      } );
    } else {
      this.reiniciarFormulario();
      this.tab = 'L';
    }
  }

  crear() {
    this.productoReferenciaParentesco = [];
    this.proReferenciaSeleccionada = null;
    this.tab = 'E';
    this.cargarFormulario();
    this.cargarCombos();
  }

  setBusqueda() {
    this.navServicio.setSearch( 'producto-referencia.component', this.busqueda );
  }

  cambioCheckRadicacion() {
    if ( !this.f.indicadorCalificarReferencias.value ) {
      this.f.idCuestionarioConfirmarReferencia.setValue( '000' );
    }
  }

  checkAnalizamosDigital(){
    if(!this.f.indicadorCanalAnalizamos.value && !this.f.indicadorCanalDigital.value){
      this.navServicio.setMesage( 0, {
        severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navServicio.buscarMensaje( 'PRODUCTOREFERENCIA.MSG_MARCARUNO' )
      } );
      return false;
    }else{
      return true;
    }
  }

  checkParentesco(){
    if(this.f.indicadorCanalDigital.value){
      const proRefParentCount = this.formulario.getRawValue();
      if(this.f.indicadorParentesco.value){
        const lista = [];
        this.listParentesco.forEach(s => {
          lista.push(s.value);
        })
        this.f.idParentescos.setValue(lista);
        return true;
      }else if(proRefParentCount.idParentescos.length>0){
        return true;
      }else{
        return false;
      }
    }else{
      const listav = [];
      this.f.idParentescos.setValue(listav);
      return true;
    }
  }

  validar(){
    if(this.checkParentesco() && this.checkAnalizamosDigital()){
      return true;
    } else {
      return false;
    }
  }

  abrirAcordeon( evento: any ) {
    switch ( evento.index ) {
      case 0: {
        this.tabSeleccionado = 'REFOBL';
        break;
      }
      case 1: {
        this.tabSeleccionado = 'REFMIN';
        break;
      }
      case 2: {
        this.tabSeleccionado = 'REFTITULAR';
        break;
      }
      default: {
        this.tabSeleccionado = 'REFOBL';
        break;
      }
    }
  }

  validarIndicadoresSistema() {
    if ( ( this.f.indicadorWeb.value && this.f.indicadorMovil.value ) ||
      ( !this.f.indicadorWeb.value && this.f.indicadorMovil.value ) ||
      ( this.f.indicadorWeb.value && !this.f.indicadorMovil.value ) ) {
      return true;
    } else {
      return false;
    }
  }
  validarFuncionalidadRequerida(){
    if (this.f.indicadorCalificarReferencias.value && this.f.indicadorCanalAnalizamos.value && this.f.indicadorCanalDigital.value){
      this.f.idFuncionalidad.setValidators([ Validators.required ]);
    }

  }
  validarFuncionalidadSeleccionada(funcionaliad: any){
    if (funcionaliad !== null || funcionaliad !== undefined){
      const funcionaliadSeleccionada = this.lisCalificacionesReferenciasTodos.find(x => x.idLista === funcionaliad);
      if (funcionaliadSeleccionada?.codigo === 'CAREFV'){
        this.indObligatorio = true;
      }else {
        this.indObligatorio = false;
        this.f.indicadorObligatorio.setValue(false);
      }
    }
  }

}
